// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"EditUser_Wrapper__2mofk","Name":"EditUser_Name__q43YN","SectionHeader":"EditUser_SectionHeader__27HfM"};